/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { PaypalCreditNoticeProps } from './index';

/**
 * Base styles for the paypal credit notice component
 *
 * @param {PaypalCreditNoticeProps} props The paypal credit notice properties object
 * */
const baseStyles = (props: PaypalCreditNoticeProps) => css`
    ${theme.typography.body_small}
`;

/**
 * The paypal credit notice component styles
 *
 * @param {PaypalCreditNoticeProps} props The paypal credit notice properties object
 * */
export const styles = (props: PaypalCreditNoticeProps) => css`
    ${baseStyles(props)}
`;
